module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "funnel-stage-mapping"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "funnel-stage-mapping__header"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "funnel-stage-mapping__header-actions"
  }, [_c('span', [_vm._v(_vm._s(_vm.rows.length) + " stage" + _vm._s(_vm.rows.length === 1 ? '' : 's') + " configured")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetToDefaults
    }
  }, [_vm._v("Reset to defaults")])])]), _vm._v(" "), (_vm.loadingConversations) ? _c('div', {
    staticClass: "funnel-stage-mapping__loading"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), _vm._v(" Loading this journey's conversations…\n  ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rows), function(row, index) {
    return _c('div', {
      key: row._uid,
      staticClass: "funnel-stage-row"
    }, [_c('div', {
      staticClass: "funnel-stage-row__number"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "funnel-stage-row__name"
    }, [_c('div', {
      staticClass: "funnel-stage-row__label"
    }, [_vm._v("STAGE " + _vm._s(index + 1))]), _vm._v(" "), (!row.isCustom) ? _c('nv-select', {
      staticClass: "form-control",
      on: {
        "change": function($event) {
          return _vm.onPresetSelected(row)
        }
      },
      model: {
        value: (row.key),
        callback: function($$v) {
          _vm.$set(row, "key", $$v)
        },
        expression: "row.key"
      }
    }, _vm._l((_vm.funnelStagePresets), function(preset) {
      return _c('option', {
        key: preset.value,
        domProps: {
          "value": preset.value
        }
      }, [_vm._v(_vm._s(preset.label))])
    }), 0) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (row.label),
        expression: "row.label"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "custom_stage_name"
      },
      domProps: {
        "value": (row.label)
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(row, "label", $event.target.value)
        }, _vm.emitChange]
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "funnel-stage-row__toggle",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.toggleCustom(row)
        }
      }
    }, [_vm._v(_vm._s(row.isCustom ? 'Use preset' : 'Free text'))]), _vm._v(" "), _c('div', {
      staticClass: "funnel-stage-row__row-actions"
    }, [_c('button', {
      staticClass: "btn btn-default btn-xs",
      attrs: {
        "type": "button",
        "disabled": index === 0,
        "title": "Move up"
      },
      on: {
        "click": function($event) {
          return _vm.moveRow(index, -1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs",
      attrs: {
        "type": "button",
        "disabled": index === _vm.rows.length - 1,
        "title": "Move down"
      },
      on: {
        "click": function($event) {
          return _vm.moveRow(index, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default btn-xs text-red",
      attrs: {
        "type": "button",
        "title": "Remove stage"
      },
      on: {
        "click": function($event) {
          return _vm.removeRow(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])], 1), _vm._v(" "), _c('div', {
      staticClass: "funnel-stage-row__mapping"
    }, [_c('div', {
      staticClass: "funnel-stage-row__mapping-label"
    }, [_vm._v("Maps to conversation stage(s) — any one triggers this funnel stage")]), _vm._v(" "), _c('div', {
      staticClass: "funnel-stage-row__chips"
    }, [(!row.conversationStages.length) ? _c('span', {
      staticClass: "text-muted"
    }, [_vm._v("No stages mapped yet — select below")]) : _vm._e(), _vm._v(" "), _vm._l((row.conversationStages), function(entry) {
      return _c('span', {
        key: _vm.chipKey(entry),
        staticClass: "funnel-stage-chip"
      }, [_c('span', {
        staticClass: "funnel-stage-chip__convo"
      }, [_vm._v(_vm._s(entry.conversation))]), _vm._v(" "), _c('i', {
        staticClass: "fa fa-angle-right"
      }), _vm._v(" " + _vm._s(entry.stage) + "\n          "), _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeConversationStage(row, entry)
          }
        }
      }, [_vm._v("×")])])
    })], 2), _vm._v(" "), _c('div', {
      staticClass: "funnel-stage-row__add"
    }, [_c('nv-select', {
      staticClass: "form-control",
      on: {
        "change": function($event) {
          row._pendingStage = ''
        }
      },
      model: {
        value: (row._pendingConversation),
        callback: function($$v) {
          _vm.$set(row, "_pendingConversation", $$v)
        },
        expression: "row._pendingConversation"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Choose conversation...")]), _vm._v(" "), _vm._l((_vm.conversations), function(convo) {
      return _c('option', {
        key: convo.name,
        domProps: {
          "value": convo.name
        }
      }, [_vm._v(_vm._s(convo.name))])
    })], 2), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      attrs: {
        "disabled": !row._pendingConversation
      },
      model: {
        value: (row._pendingStage),
        callback: function($$v) {
          _vm.$set(row, "_pendingStage", $$v)
        },
        expression: "row._pendingStage"
      }
    }, [_c('option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("Choose stage...")]), _vm._v(" "), _vm._l((_vm.availableStagesFor(row)), function(stageKey) {
      return _c('option', {
        key: stageKey,
        domProps: {
          "value": stageKey
        }
      }, [_vm._v(_vm._s(stageKey))])
    })], 2), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      attrs: {
        "type": "button",
        "disabled": !row._pendingStage
      },
      on: {
        "click": function($event) {
          return _vm.addConversationStages(row)
        }
      }
    }, [_vm._v("\n          + Add\n        ")])], 1), _vm._v(" "), (row._pendingStage) ? _c('div', {
      staticClass: "funnel-stage-row__options"
    }, [_c('div', {
      staticClass: "funnel-stage-row__options-label"
    }, [_vm._v("\n          Answer options detected for this stage\n        ")]), _vm._v(" "), (_vm.pendingOptions(row).length) ? _c('div', {
      staticClass: "funnel-stage-row__chips"
    }, _vm._l((_vm.pendingOptions(row)), function(opt) {
      return _c('span', {
        key: opt,
        staticClass: "funnel-stage-chip funnel-stage-chip--readonly"
      }, [_vm._v(_vm._s(opt))])
    }), 0) : _c('div', {
      staticClass: "text-muted"
    }, [_vm._v("No answer options detected for this stage.")])]) : _vm._e()])])
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default funnel-stage-mapping__add-stage",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addRow
    }
  }, [_vm._v("+ Add funnel stage")])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "funnel-stage-mapping__intro"
  }, [_c('strong', [_vm._v("Left:")]), _vm._v(" funnel stage name and order. "), _c('strong', [_vm._v("Right:")]), _vm._v(" conversation and stage(s) that trigger it — reaching "), _c('em', [_vm._v("any one")]), _vm._v(" is enough.\n    "), _c('strong', [_vm._v("Cumulative:")]), _vm._v(" reaching a later stage automatically counts the user in all earlier stages.\n  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "funnel-stage-mapping__title"
  }, [_vm._v("Funnel Stages")]), _vm._v(" "), _c('div', {
    staticClass: "funnel-stage-mapping__subtitle"
  }, [_vm._v("Add stages in order. Each maps to conversation stage(s), from this journey or any conversation it embeds.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-61b8aa8f","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/FunnelStageMapping.vue
// module id = /k+v
// module chunks = 1